"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Title = _interopRequireDefault(require("../../Title"));

var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function Test(props) {
  var data = props.data,
      kindType = props.type,
      _a = props.hasTopPadding,
      hasTopPadding = _a === void 0 ? false : _a,
      flexTitle = props.flexTitle,
      desc = props.desc,
      mergeComponentStatus = props.mergeComponentStatus,
      flexSmallTitle = props.flexSmallTitle,
      layoutMode = props.layoutMode;

  var _b = data || {},
      _c = _b.configuration,
      configuration = _c === void 0 ? [] : _c,
      title = _b.title;

  if (configuration.length < 1) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (flexTitle || desc || flexSmallTitle) && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('product-resource-container__txt', {
      'has-no-padding-top': !hasTopPadding,
      'has-padding-top': hasTopPadding
    })
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'h3'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('product-resource-container__txt--card', {
      'has-no-padding-top': !title
    })
  }, configuration.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(Render, __assign({
      key: index
    }, item, {
      kindType: kindType,
      layoutMode: layoutMode,
      index: index,
      record: configuration || []
    }));
  }))));
}

function Render(props) {
  var head = props.head,
      kindType = props.kindType,
      description = props.description,
      index = props.index,
      record = props.record,
      title = props.title,
      layoutMode = props.layoutMode;
  var containerRefs = (0, _react.useRef)(null); // const containerRefs2 = useRef(null) as any;

  var containerRefsOrigin = (0, _react.useRef)(null);
  var realHeight = (0, _react.useRef)(null);
  var shoDomeRef = (0, _react.useRef)(null); // 展示的dome

  var leftDemo = (0, _react.useRef)(null); // 展示的dome

  var hoverRef = (0, _react.useRef)(null);
  var heightVal = 0;
  var heightValInit = 0;
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (containerRefs.current) {
        if (shoDomeRef.current.clientHeight <= containerRefsOrigin.current.clientHeight + 10) {
          containerRefs.current.className = containerRefs.current.className + " shade";
        } else {
          containerRefs.current.className = "content";
          hoverRef.current.className = hoverRef.current.className + " fade-out";
        }

        heightVal = containerRefsOrigin.current.clientHeight;
        heightValInit = shoDomeRef.current.clientHeight;
        realHeight.current.style.maxHeight = heightVal + "px";
      }

      if (status) {
        addOnMouseOver();
      } else {// containerRefsOrigin.current.style.height = `${
        //   heightValInit > heightVal ? heightVal : heightValInit
        // }px`;
        // addOnMouseClick();
      }
    });
  }, []);

  var addOnMouseOver = function addOnMouseOver() {
    if (!containerRefsOrigin.current) return true;

    containerRefsOrigin.current.onmouseover = function () {
      realHeight.current.style.maxHeight = (heightValInit > heightVal ? heightValInit - 46 : heightVal) + "px";
    };

    containerRefsOrigin.current.onmouseout = function () {
      realHeight.current.style.maxHeight = heightVal + "px";
    };
  }; // let lock = false;
  // const addOnMouseClick = () => {
  //   if (!containerRefsOrigin.current) return true;
  //
  //   containerRefsOrigin.current.onmousedown = () => {
  //     if (lock) {
  //       realHeight.current.style.height = `${heightValInit}px`;
  //     } else {
  //       realHeight.current.style.height = `${
  //         heightVal > heightValInit ? heightVal : heightValInit
  //       }px`;
  //     }
  //     lock = !lock;
  //   };
  // };


  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('main-container', {
      'is-layooutmode': layoutMode
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    key: index,
    className: 'main',
    ref: containerRefsOrigin,
    style: {
      zIndex: record.length - index || 1
    }
  }, [1, 2].map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: item === 1 ? 'leftChild' : 'rightChild',
      ref: item === 1 ? leftDemo : realHeight
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('list-txt'),
      ref: shoDomeRef
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('head', {
        'head--cyan': ['cyan'].includes(kindType),
        'head--blue': ['blue'].includes(kindType)
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, head)), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('subtitle-container', {
        'subtitle-container--blue': ['blue'].includes(kindType),
        'subtitle-container--cyan': ['cyan'].includes(kindType),
        'is-layooutmode': layoutMode
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, title)), /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      ref: item === 2 ? containerRefs : null,
      className: (0, _classnames["default"])('content', {
        'a-href': ['cyan'].includes(kindType)
      }),
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'fade-svg',
      ref: item === 2 ? hoverRef : null
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13",
      height: "8",
      viewBox: "0 0 13 8",
      fill: "none"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.554688 1.70718L2.02783 0.292969L6.49959 4.58586L10.9714 0.292969L12.4445 1.70718L6.49959 7.41429L0.554688 1.70718Z",
      fill: "currentColor"
    })))));
  })));
}

var NewDocument = function NewDocument(props) {
  var paddingTopNum = props.paddingTopNum,
      paddingBottomNum = props.paddingBottomNum,
      flexTitle = props.flexTitle,
      style = props.style,
      isFooterPart = props.isFooterPart,
      isCombination = props.isCombination,
      isPadding = props.isPadding;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isPadding: isPadding,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(Test, __assign({}, props)));
};

var _default = NewDocument;
exports["default"] = _default;